export default __webpack_public_path__ + "static/media/feature1_2.67848a58.png";